// Single source of truth is package.json's "version". The `prebuild` script
// writes it into REACT_APP_VERSION; the literal is the dev/runtime fallback.
export const APP_VERSION = process.env.REACT_APP_VERSION || "0.23.4";
